import { useEffect, useRef, useState } from "react";

import { podeTocarVideo, urlMidia } from "./midiasPublicas";

// Tempo na tela antes de criar o vídeo: quem rola rápido não baixa nada
const ESPERA_MS = 300;

/**
 * O vídeo do produto no cartão do cardápio, por cima da foto (pedido do dono,
 * 23/10/2026: com o vídeo como destaque, ele fica tocando no cardápio).
 *
 * Para não pesar: a foto aparece na hora (é a do próprio cartão); o vídeo só é
 * criado quando o cartão fica na tela por um instante, carrega sem bloquear
 * nada e aparece por cima quando já está tocando. Saiu da tela → o vídeo é
 * desmontado e o download para (no iPhone, vários vídeos pausados seguram
 * memória). Economia de dados ou "reduzir movimento" no celular → só a foto.
 */
export default function VideoDoCartao({ midias, className = "" }) {
  const primeira = midias?.[0];
  const caixa = useRef(null);
  const [visivel, setVisivel] = useState(false);
  const [tocando, setTocando] = useState(false);
  const ehVideo = primeira?.tipo === "video" && podeTocarVideo();

  useEffect(() => {
    if (!ehVideo || !caixa.current || typeof IntersectionObserver === "undefined") return undefined;
    let espera = null;
    const obs = new IntersectionObserver(([e]) => {
      clearTimeout(espera);
      if (e.isIntersecting && e.intersectionRatio >= 0.5) espera = setTimeout(() => setVisivel(true), ESPERA_MS);
      else { setVisivel(false); setTocando(false); }
    }, { threshold: [0, 0.5] });
    obs.observe(caixa.current);
    return () => { clearTimeout(espera); obs.disconnect(); };
  }, [ehVideo]);

  if (!ehVideo) return null;
  return (
    <div ref={caixa} className={`absolute inset-0 pointer-events-none ${className}`}>
      {visivel && (
        <VideoQueSolta src={urlMidia(primeira.url)} onPlaying={() => setTocando(true)}
          className={`w-full h-full object-cover transition-opacity duration-500 ${tocando ? "opacity-100" : "opacity-0"}`} />
      )}
    </div>
  );
}

/** <video> que, ao sair da tela, solta o arquivo (sem isso o download segue até o coletor de lixo). */
function VideoQueSolta({ src, onPlaying, className }) {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    return () => { if (v) { v.pause(); v.removeAttribute("src"); v.load(); } };
  }, []);
  return <video ref={ref} src={src} muted loop playsInline autoPlay preload="auto" onPlaying={onPlaying} aria-hidden className={className} />;
}
